/**
 * Ð§ÑÐ¾ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð² Ð¿ÑÐ¾ÑÐ¸Ð»Ðµ Ð² Ð¿Ð¾Ð»Ðµ Â«ÐÐ²ÑÐ¾ÑÐ°Ð»Ð¾Ð½Â».
 *
 * Ð Ð°Ð½ÑÑÐµ Ð·Ð´ÐµÑÑ ÑÑÐ¾ÑÐ»Ð° ÑÑÑÐ¾ÐºÐ° Â«Kia DOSCAR: ÑÐ». ÐÐ»ÐµÐ±ÐµÐºÐ¾Ð²Ð°, 10/1Â», Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²Ð°Ñ Ð´Ð»Ñ
 * Ð²ÑÐµÑ: ÑÑÐºÐ¾Ð²Ð¾Ð´Ð¸ÑÐµÐ»Ñ Ð¸Ð· ÐÑÑÐ°Ð½Ñ Ð²Ð¸Ð´ÐµÐ» Ð°Ð»Ð¼Ð°ÑÐ¸Ð½ÑÐºÐ¸Ð¹ Ð°Ð´ÑÐµÑ. ÐÐµÑÑÐ¼ ÑÐµÐ½ÑÑÑ ÑÐ°Ð¼Ð¾Ð³Ð¾
 * Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ â ÑÐµ Ð¶Ðµ, ÑÑÐ¾ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÑÑ ÐµÐ³Ð¾ Ð´Ð¾ÑÑÑÐ¿ Ðº ÑÐ´ÐµÐ»ÐºÐ°Ð¼.
 */
export const dealerCentresText = (user) => {
  const centres = user?.dealerCenters || [];
  if (centres.length === 0) return 'â';
  return centres
    .map((dc) => {
      const name = (dc?.name || '').trim();
      const address = (dc?.address || '').replace(/\s+/g, ' ').trim();
      return address ? `${name}: ${address}` : name;
    })
    .filter(Boolean)
    .join('; ');
};

/** ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐ¾Ð»Ð¸; Ð¿Ð¾ÐºÐ° Ð±ÑÐºÐµÐ½Ð´ Ð½Ðµ Ð¾ÑÐ´Ð°ÑÑ ÐµÐ³Ð¾ â Ð¿ÑÑÑÐ¾, Ð° Ð½Ðµ Â«undefinedÂ». */
export const roleText = (user) => user?.roleTitle || user?.role?.title || 'â';
